(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-is-user-afk.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-is-user-afk.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_map.atoms,
  isMovingAtom = _svs$lyckoplatsen$sha.isMovingAtom,
  isUserIdleAtom = _svs$lyckoplatsen$sha.isUserIdleAtom,
  mapZoomLevelAtom = _svs$lyckoplatsen$sha.mapZoomLevelAtom;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const pinLocationAtom = svs.lyckoplatsen.components.page_play.jotai.atoms.pinLocationAtom;
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks', {
  useIsUserAfk: () => {
    const pinLocation = useAtomValue(pinLocationAtom);
    const isMoving = useAtomValue(isMovingAtom);
    const setIsUserIdle = useSetAtom(isUserIdleAtom);
    const charity = useAtomValue(charityAtom);
    const zoomLevel = useAtomValue(mapZoomLevelAtom);
    const idleTime = charity ? 500 : 6000;
    useEffect(() => {
      let timerAfterId;
      if (!isMoving && zoomLevel < CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
        timerAfterId = setTimeout(() => {
          setIsUserIdle(true);
        }, idleTime);
      }
      if (pinLocation.lng || isMoving || zoomLevel >= CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
        clearTimeout(timerAfterId);
        setIsUserIdle(false);
      }
      return () => clearTimeout(timerAfterId);
    }, [isMoving, idleTime, pinLocation, setIsUserIdle, zoomLevel]);
  }
});

 })(window);